<template>
  <div class="empty-state" :class="`empty-state--${variant}`">
    <div class="empty-state-icon">
      <vue-feather :type="iconType" size="40" stroke-width="1.5" />
    </div>
    <p class="empty-state-title">{{ title }}</p>
    <p v-if="subtitle" class="empty-state-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
import VueFeather from 'vue-feather'

// A page or panel's whole content when it isn't available to this account or failed to load:
// fills its flex parent and sets the message a third of the way down
export default {
  name: 'EmptyState',
  components: { VueFeather },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    // 'danger' when something went wrong
    variant: { type: String, default: 'default', validator: v => ['default', 'danger'].includes(v) }
  },
  computed: {
    // One generic icon per kind of state, never one per page: "not available" or "something went wrong"
    iconType() {
      return this.variant === 'danger' ? 'alert-triangle' : 'slash'
    }
  }
}
</script>

<style scoped>
.empty-state {
  --empty-state-color: #9ca3af;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
}

/* Spacers split the free space 1 : 2, so the message sits a third of the way down rather than dead center */
.empty-state::before,
.empty-state::after {
  content: '';
}

.empty-state::before {
  flex: 1;
}

.empty-state::after {
  flex: 2;
}

.empty-state--danger {
  --empty-state-color: var(--color-status-danger);
}

.empty-state-icon {
  display: flex;
  flex-shrink: 0;
  margin-bottom: 16px;
  color: var(--empty-state-color);
}

.empty-state-title,
.empty-state-subtitle {
  max-width: 520px;
  /* Wrapped lines come out even, never one word left alone on the last */
  text-wrap: balance;
}

.empty-state-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-txt-dark);
}

.empty-state-subtitle {
  margin: 4px 0 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--color-txt-light);
}
</style>
